<template>
    <div id="home">
		<div @click="onClickBack"  class="custom_back_icon">
			<van-icon size="18" name="arrow-left" style="margin-top: 3px; margin-left: 2px;"/>
		</div>
		<div class="custom_info_title">
		  <span class="div_title">
				{{ wz_mc }}
			</span>
		</div>
		<div class="custom_body">
			<van-swipe :autoplay="3000" style="height: 200px;border-radius: 15px;">
					  <van-swipe-item
						  v-for="(image, index) in infoList"
						  :key="index"
						  :style="userStyle(image)"
						  class="custom_swipe"
						  @click="viewImages(image)"
					  >
						  <img
							  v-lazy="image.wz_img"
							  width="auto"
							  height="100%"
						  />
					  </van-swipe-item>
			</van-swipe>
			
			<div class="home_page">
			<div style="width: 100%; margin-top: 15px">
			  <div class="custom_info_line">物资详情</div>
			  <div class="div_xq">

					<div style="width: 100%; display: flex">
					  <span >
						型号：{{ wz_gg}}</span>
					</div>
				
			    <div style="margin-top: 3px; width: 100%;">
			      <span >
					  不含税：{{ infoDetail.wz_jg_bhs}}{{ infoDetail.wz_dw }}
				  </span>
			    </div>
				<div style="margin-top: 3px;">
				  <span>
					  含税：{{ infoDetail.wz_jg_hs}}{{ infoDetail.wz_dw }}
					</span>
				</div>
			    <div style="margin-top: 3px;">
			      <span>
					 详情：{{ infoDetail.wz_ms }}
				  </span>
			    </div>
			  </div>
			</div>
			<div style="width: 100%; margin-top: 15px">
			  <div class="custom_info_line">厂家信息</div>
			  <div class="div_xq">
					<div style="width: 100%; display: flex">
					  <span >
						{{ infoDetail.ghs_mc}}</span>
					</div>
				<div style="width: 100%; display: flex">
				  <span >
					{{ infoDetail.ghs_tel}}</span>
				</div>
			    <div style="margin-top: 3px; width: 100%;transform: translateX(-11px);">
					<van-icon size="14" name="underway-o" style="transform: translateY(2px)" ></van-icon>
			      <span style="color: rgb(192, 192, 192);font-size: 14px;">
					  {{ infoDetail.cjsj}}
				  </span>
			    </div>
			  </div>
			</div>
			<div style="width: 100%; margin-top: 15px">
				  <div class="custom_info_line">相关发布</div>
				  <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->
				      <div class="div_detail">
				          <van-list
				              v-show="!showEmpty"
				              v-model="loading"
				              :finished="finished"
				              finished-text="没有更多了"
				              :immediate-check="false"
				              @load="listenOnLoad"
				          >
				              <div
				                  class="div_select"
				                  v-for="(item, index) in infoHistoryList"
				                  :key="index"
				                  @click="showHistoryItem(item)"
				              >
				                  <div class="div_select_img" v-if="item.wz_img">
				                      <img
				                          :src="item.wz_img"
				                          width="65px"
				                          height="65px"
				                      />
				                  </div>
								  <div class="div_select_img div_select_left" v-else>
								      <span
								          style="
								              display: table-cell;
								              vertical-align: middle;
								              justify-content: center;
								          "
								          >最低价<br />
								          {{ item.wz_jg_bhs }}元/{{
								              item.wz_dw
								          }}</span
								      >
								  </div>
				                 <!-- <div class="div_select_detail">
				                      <div>
				                          <span
				                              ><span style="font-weight: 700"
				                                  >发布时间：</span
				                              >{{ item.cjsj }}</span
				                          >
				                          <span style="float: right; color: green"
				                              >{{ item.llcs }}人浏览</span
				                          >
				                      </div>
				                      <div class="div_yichu">
				                          <div class="div_yichu_left">
				                              <span style="font-weight: 700"
				                                  >名称：</span
				                              >{{ item.wz_mc }}
				                          </div>
				                          <div class="div_yichu_right">
				                              <span style="font-weight: 700"
				                                  >型号：</span
				                              >{{ item.wz_gg }}
				                          </div>
				                      </div>
				                      <div class="div_yichu">
				                          <div class="div_yichu_left">
				                              <span style="font-weight: 700"
				                                  >不含税：</span
				                              >{{ item.wz_jg_bhs }}{{ item.wz_dw }}
				                          </div>
				                          <div class="div_yichu_right">
				                              <span style="font-weight: 700"
				                                  >含税：</span
				                              >{{ item.wz_jg_hs }}{{ item.wz_dw }}
				                          </div>
				                      </div>
				                      <div>
				                          <span style="font-weight: 700">详情：</span
				                          >{{ item.wz_ms }}
				                      </div>
				                  </div> -->
								  <div class="div_select_zhong">
									 <div class="div_yichu">
										 <div
											 class="div_yichu_left"
											 style="font-weight: 700;width: 100%;"
										 >
											 {{ item.wz_mc }}
										 </div>
									 </div>
		  
									 <div class="div_yichu fbt_title">
										 <div class="div_yichu_left" style="width:100%">
											 {{ item.wz_gg }}
										 </div>
									 </div>
									 <div class="div_yichu fbt_title">
										 <div class="div_yichu_left">
											 不含税：{{ item.wz_jg_bhs }}{{ item.wz_dw }}
										 </div>
										 <div class="div_yichu_right">
											 含税：{{ item.wz_jg_hs }}{{ item.wz_dw }}
										 </div>
									 </div>
								 </div>
				              </div>
				          </van-list>
				      </div>
				  <!-- </van-pull-refresh> -->
				</div>
			
        </div>
        </div>
	</div>
</template>

<script>
import echarts from "echarts";
import Vue from "vue";
import { Col, Dialog, Lazyload, Toast, PullRefresh,ImagePreview } from "vant";
import defaultPic from "../../assets/Images/default-pic.png";

// 全局注册
Vue.use(Dialog);
Vue.use(Lazyload);
Vue.use(Toast);
Vue.use(PullRefresh);
Vue.prototype.$echarts = echarts;
export default {
    name: "PriceArticle",
    data() {
        return {
            infoList: [], //信息列表
			infoDetail:{},//第一条信息详情
			infoHistoryList:[], // 历史信息列表
            loading: true,
            finished: false,
            defaultPic: defaultPic, //默认头像
            showEmpty: false,
            isLoading: "", //下拉刷新的加载过程
            wzlxid: this.$route.query.wzlxid,
            wz_mc: this.$route.query.wz_mc,
            wz_gg: this.$route.query.wz_gg,
			showWzId:null, // 当前展示的物资id
        };
    },
    components: {
        [Dialog.Component.name]: Dialog.Component,
    },

    beforeRouteLeave(to, from, next) {
        //要在离开该组件的时候控制需要缓存的组件，否则将出现第一次不缓存的情况
        // this.busy = true;
        let keepAliveList = this.$store.getters.keepAlive;
        if (from.meta.keepAlive && !keepAliveList.includes(from.name)) {
            keepAliveList.push(from.name);
            // 去往详情页的时候需要缓存组件，其他情况下不需要缓存
            this.$store.commit("keepAliveMut", keepAliveList); //注意，'home'将匹配首先检查组件自身的 name 选项（非router.js里的），如果 name 选项不可用，则匹配它的局部注册名称 (父组件 components 选项的键值)。匿名组件不能被匹配。
        }
        next();
    },
    computed: {},
    mounted() {
        this.getInfoList();
    },
    methods: {
		userStyle(image){
				  return {'background-image':`url(${image.wz_img})`}
		},
		viewImages(image){
			ImagePreview([image.wz_img])
		},
        //点击页面中的数据时
        onClickBack() {
            this.$router.replace("FactoryPrice");
        },
        onRefresh() {
            this.getInfoList(1);
        },

        //获取信息数据进行渲染
        getInfoList(val) {
            let url = this.baseUrl + "/NewJiaGe/getFactory",
                params = {
                    wzlxid: this.wzlxid,
                    wz_mc: this.wz_mc,
                    wz_gg: this.wz_gg,
                };
            this.$ajax(url, params).then(
                (res) => {
                    this.infoList = JSON.parse(res.data.msg);
                    this.infoList.forEach((e) => {
                        e.cjsj = this.date_time4(e.cjsj);
						e.wz_img = e.wz_img || this.defaultPic
                    });
					this.infoDetail =  this.infoList[0] || {}; // 获取当前信息详情
					this.showWzId =  this.infoList[0].id;// 暂存当前信息id 方便在获取历史记录的时候排除
					this.getInfoHistoryList(); // 查询全部记录
                    this.loading = false;
                    Toast.clear();
                    this.isLoading = false;
                    this.finished = true;
                },
                (err) => {
                    Toast.clear();
                    this.finished = true;
                    this.loading = false;
                    this.isLoading = false;
                }
            );
        },
		//获取信息数据进行渲染
		getInfoHistoryList() {
		    let url = this.baseUrl + "/NewJiaGe/getFactoryPublishLists",
		        params = {
		            ghs_tel: this.infoDetail.ghs_tel,
		        };
		    this.$ajax(url, params).then(
		        (res) => {
		            this.infoHistoryList = (JSON.parse(res.data.msg) || []).filter(ele => ele.id != this.showWzId);
		            // this.ghs_telnumber = this.infoHistoryList[0].ghs_tel;
		            // this.ghs_name = this.infoHistoryList[0].ghs_mc;
		            // let tel = this.infoHistoryList[0].ghs_tel;
		            // this.titleTel = tel.substr(0, 3) + "****" + tel.substr(7);
		
		            this.infoHistoryList.forEach((e) => {
		                e.cjsj = this.date_time4(e.cjsj);
		            });
		            this.loading = false;
		            Toast.clear();
		            this.isLoading = false;
		            this.finished = true;
		        },
		        (err) => {
		            Toast.clear();
		            this.finished = true;
		            this.loading = false;
		            this.isLoading = false;
		        }
		    );
		},
		showHistoryItem(row){
			const {wzlxid,wz_mc,wz_gg} = row
			let cloneRow = JSON.parse(JSON.stringify(row));// 克隆一份数据
			this.wzlxid = wzlxid;
			this.wz_mc = wz_mc;
			this.wz_gg = wz_gg;
			cloneRow.wz_img = cloneRow.wz_img || this.defaultPic
			this.infoList = [cloneRow];
			this.infoDetail =  cloneRow || {}; // 获取当前信息详情
			this.showWzId =  cloneRow.id;// 暂存当前信息id 方便在获取历史记录的时候排除
			let dom = document.querySelector(".custom_body");
			dom && (dom.scrollTop = 0);
			this.getInfoHistoryList(); // 刷新历史记录
		},
        //页面触底加载更多数据
        listenOnLoad() {
            this.getInfoList();
        },
        //点击页面中的数据时
        onClickToDetail(item) {
            this.updateSeeCountsByFactory(item.ghs_tel);
            this.$router.replace({
                //因存在微信公众号里向用户推送模板消息,可通过模板消息的redirect重定向的详情页，参数为"url?param=value"
                //因此此处只能用path、query,不能用name、params
                path: "/FactoryWzList",
                query: {
                    ghs_tel: item.ghs_tel,
                    wzlxid: this.wzlxid,
                    wzlxmc: this.wzlxmc,
                    wz_mc: this.wz_mc,
                    wz_gg: this.wz_gg,
                },
            });
        },
        updateSeeCountsByFactory(val) {
            let url = this.baseUrl + "/NewJiaGe/updateSeeCountsByFactory",
                params = {
                    ghs_tel: val,
                    wzlxid: this.wzlxid,
                },
                otherObj = {
                    method: "post",
                    loadFlag: false,
                    errUrl: "",
                };
            this.$ajax(url, params, otherObj).then(
                (res) => {},
                (err) => {}
            );
        },
    },
};
</script>
<style scoped>
.div_navbar {
    width: 100%;
}
#home {
    font-size: 12px;
    /* width: 100%; */
    /* height: 100vh; */
	height: calc(100vh - 80px);
    background-color: #fff;
	padding: 10px 10px;
}
.head {
    padding-top: 10px;
    min-height: 50px;
    background-color: white;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    border-bottom: solid 0.5px #e8e8e8;
}
/* .div_detail {
    background-color: #e8e8e8;
} */
.div_select {
    border-radius: 5px;
    padding: 5px 10px;
    margin-bottom: 1px;
    background-color: rgb(255, 255, 255);
    display: flex;
    align-content: center;
}
.div_select_img {
    margin-top: 6px;
    width: 20%;
}
.div_select_detail {
    float: right;
    width: 80%;
    color: gray;
	margin-left: 10px;
}
.div_yichu_span {
    margin-top: 3px;
}
.custom_swipe {
  position: relative;
  text-align: center;
  overflow: hidden;
  backdrop-filter: blur(5px);
  background-size: 100%;
}
.custom_swipe::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(239 239 239 / 50%);
  backdrop-filter: blur(5px);
  background-size: 100%;
  opacity: 0.8;
  z-index: -1;
}
.custom_info_title{
	width: 94%; 
	margin-left: 3%; 
	margin-bottom: 25px;
	text-align: center;
}
.div_title { 
  color: rgb(0, 0, 0);
  font-weight: 700; 
  font-size: 18px;
  width: 270px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}
.custom_info_line{
	font-weight: 600;
	font-size: 14px;
	margin-top: 10px;
	position: relative;
	padding-left: 10px;
}
.custom_info_line::before{
	content: " ";
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 4px;
	background-color: #ffd01e;
}
.div_xq {
  padding: 2px;
  width: 93%;
  padding-left: 10px;
  color: rgb(0, 0, 0);
  font-size: 14px;
  border-radius: 5px;
}
.div_xq > div{
	margin: 10px 0;
	position: relative;
}
.custom_back_icon{
	position: absolute;
	background-color: gray;
	opacity: 0.8;
	color: white;
	width: 25px;
	top: 10px;
	left: 10px;
	border-radius: 12px;
	height: 25px;
	z-index: 5;
}
.custom_body{
	height: calc(100vh - 131px);
	overflow: auto;
}
/* 参考价 */
.div_select_left {
    height: 60px;
    display: table;
    position: relative;
    width: 80px;
    align-self: center;
    text-align: center;
    background-color: rgb(164, 190, 177);
    border-radius: 4px;
    color: white;
}
.div_yichu {
    margin-left: 10px;
    margin-top: 2px;
    color: #2c2c2c;
    display: flex;
    align-content: space-between;
}
.div_yichu_left {
    width: 50%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.div_yichu_right {
    width: 50%;
    text-align: right;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
/* 中间的盒子 */
.div_select_zhong {
    width: calc(98% - 80px);
    float: left;
    margin-left: 3px;
    margin-top: 5px;
    flex-direction: column;
    justify-content: center;
    background-color: rgb(255, 255, 255);
    border-radius: 8px;
    font-size: 14px;
}
/* 文本副标题 */
.fbt_title{
	color:#4a4a4a
}
</style>
